var Admin = {
    bindLevelAccordions: function() {
        $('.admin-level-accordion').off('click').on('click', function() {
            var accordion = $(this);
            var levelId = $(this).data('level');
            var tbody = $('#tbody-' + levelId);
            if (tbody.children().length <= 0 && !accordion.hasClass('loading')) {
                var loadingDiv = '<div class="loader-container"><div class="cssload-loader"></div></div>';
                accordion.prepend(loadingDiv);
                var subjectId = $('.statement-select')[0].value;
                $.get('/statements/ajax?frameworkId=' + frameworkId + '&levelId=' + levelId + '&subjectId=' + subjectId, function(data) {
                    tbody.html(data);
                    //$('#level-' + levelId).show();
                    accordion.removeClass('loading').find('.loader-container').remove().addClass('active');
                    App.initDeleteConfirm();
                });
            }
        });
    },

    bindAddStatement: function() {
        $('.add-statement').click(function(e){
           e.stopPropagation();
        });
    },

    bindCreateTermlyTargets: function() {
        $('#createTermlyTargets').click(function() {
            /* suppress smart fill based on current progress option
            if ($(this).is(':checked')) {
                $('#smartFillCurrentContainer').slideDown();
            } else {
                $('#smartFillCurrentContainer').slideUp();
                $('#smartFillCurrent').attr('checked', false);
            }
            */
        });
    },
};

$(document).ready(function() {
    // TODO: TIDY THIS UP
    $('#user_group_id').change(function() {
        var newsletterContainer = $('#newsletterContainer');
        var newsletterInput = $('#newsletter');
        var text = $("#user_group_id option:selected").text();
        console.log(text);
        if (text != 'Management') {
            newsletterContainer.slideUp('fast');
            newsletterInput.attr('disabled', true);
            return false;
        }
        newsletterContainer.slideDown('fast');
        newsletterInput.attr('disabled', false);
    });

    $('.pupil-restore').click(function(e) {
        e.preventDefault();
        var btn = $(this);
        var pupilId = btn.data('pupil');
        var row = $('#pupil-' + pupilId + '-row');
        var url = btn.attr('href');

        $.get(url, function(response) {
            if (!response.success) {
                alert('Action failed. Please check Pupil Limit.');
                return false;
            }
            alert('Action successful!');
            row.remove();
        });
    });

    $('.user-restore').click(function(e) {
        e.preventDefault();
        var btn = $(this);
        var userId = btn.data('user');
        var row = $('#user-' + userId + '-row');
        var url = btn.attr('href');

        $.get(url, function(response) {
            if (!response.success) {
                alert('Action failed. Please try again.');
                return false;
            }
            alert('Action successful!');
            row.remove();
        });
    });

    $('.iep-restore').click(function(e) {
        e.preventDefault();
        var btn = $(this);
        var iepId = btn.data('iep');
        var row = $('#iep-' + iepId + '-row');
        var url = btn.attr('href');

        $.get(url, function(response) {
            if (!response.success) {
                alert('Action failed.');
                return false;
            }
            alert('Action successful!');
            row.remove();
        });
    });

    $('.incident-restore').click(function(e) {
        e.preventDefault();
        var btn = $(this);
        var incidentId = btn.data('incident');
        var row = $('#incident-' + incidentId + '-row');
        var url = btn.attr('href');

        $.get(url, function(response) {
            if (!response.success) {
                alert('Action failed.');
                return false;
            }
            alert('Action successful!');
            row.remove();
        });
    });

    $('.peep-restore').click(function(e) {
        e.preventDefault();
        var btn = $(this);
        var peepId = btn.data('peep');
        var row = $('#peep-' + peepId + '-row');
        var url = btn.attr('href');

        $.get(url, function(response) {
            if (!response.success) {
                alert('Action failed.');
                return false;
            }
            alert('Action successful!');
            row.remove();
        });
    });

    $('#school').change(function() {
        var select = $(this);
        var targetSelect = $('#user');
        var school = select.val();
        var type = $(this).data('type');
        var url = '/admin/users/teachers?school=' + school;

        if (type == 'frameworks') {
            url = '/soladmin/frameworks/ajax?school=' + school;
            targetSelect = $('#framework');
        }

        if (type == 'framework-subjects') {
            url = '/soladmin/frameworks/ajax?school=' + school;
            targetSelect = $('#framework-subject');
        }

        $.get(url, function(data) {
            if (type == 'framework-subjects') {
                // get initial first framework option
                var topVal = data[0].id;
                data.unshift({'id': '', 'text': 'All Frameworks'});
            }
            targetSelect.empty();
            targetSelect.select2({
                data: data
            }).change();
            if (type == 'framework-subjects') {
                // set dropdown back to first framework option
                targetSelect.val(topVal);
                targetSelect.select2().trigger('change');
            }
        });
    });

    $('#framework').change(function() {
        var school = $('#school').val();
        var framework = $(this).val();
        $.get('/admin/frameworks/stars/ajax?school=' + school + '&framework=' + framework, function(data) {
            var stars = $('#stars');
            stars.html(data);
            $('#addStar').show();
        });
    });

    $('#framework-subject').change(function() {
        var select = $(this);
        var targetSelect = $('#subject');
        var school = $('#school').val();
        var framework = select.val();
        url = '/admin/frameworks/subjects/ajax?school=' + school + '&framework=' + framework;

        $.get(url, function(data) {
            /* All Subjects replaces Select Subjects (no longer prepended in FrameworkController@ajaxSubjects)
            if (framework == '') {
            */
                // get initial first subject option
                var topVal = data[0].id;
                data.unshift({'id': '', 'text': 'All Subjects'});
            /*
            }
            */
            targetSelect.empty();
            targetSelect.select2({
                data: data
            }).change();
            /* All Subjects replaces Select Subjects (no longer prepended in FrameworkController@ajaxSubjects)
            if (framework == '') {
            */
                // set dropdown back to first subject option
                targetSelect.val(topVal);
                targetSelect.select2().trigger('change');
            /*
            }
            */
        });

    });


    //Terms
    $('#date_of_birth').datepicker({
        format: 'dd/mm/yyyy',
        autoclose: true,
        todayBtn: true, // Show a 'Today' button at the bottom, selecting it selects the current date
    });

    $('#date_on_roll').datepicker({
        format: 'dd/mm/yyyy',
        autoclose: true,
        todayBtn: true, // Show a 'Today' button at the bottom, selecting it selects the current date
    });

    var startDate =  $('#start-date');
    var endDate = $('#end-date');

    startDate.datepicker({
        format: 'D d MM yyyy',
        autoclose: true,
        todayBtn: 'linked', // Show a 'Today' button at the bottom, selecting it selects the current date
        weekStart: 1 // Start weeks on Monday,
    });
    endDate.datepicker({
        format: 'D d MM yyyy',
        autoclose: true,
        todayBtn: 'linked', // Show a 'Today' button at the bottom, selecting it selects the current date
        weekStart: 1 // Start weeks on Monday,

    });
    // if (startDate.val()) {
    //     startDate.datepicker('update', startDate.val());
    // }
    // if (endDate.val()) {
    //     endDate.datepicker('update', endDate.val());
    // }

    // if ($('#static-value')) {
    //     var staticVal = $('#static-value').val();
    //     $('#input_type').val(staticVal);
    // }

    // Disabilities
    $('#disabilityModal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget);
        var disabilityToHide = button.data('hideid');

        var modal = $(this);
        modal.find('select option').prop('disabled', false);
        modal.find('select option[value=' + disabilityToHide + ']').prop('disabled', true);
        modal.find('select').select2('destroy').select2().select2('val', modal.find('select option:eq(2)').val());
        modal.find('.disability_id').val(disabilityToHide);
    });

    //Learning Needs
    $('#learningModal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget);
        var disabilityToHide = button.data('hideid');

        var modal = $(this);
        modal.find('select option').prop('disabled', false);
        modal.find('select option[value=' + disabilityToHide + ']').prop('disabled', true);
        modal.find('select').select2('destroy').select2().select2('val', modal.find('select option:eq(2)').val());
        modal.find('.learning_need_id').val(disabilityToHide);
    });

    //Tutor Groups
    $('#tutorModal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget);
        var disabilityToHide = button.data('hideid');
        var tutor = button.data('tutorname');
        $(".tutorText").remove();

        var modal = $(this);
        modal.find('select option').prop('disabled', false);
        modal.find('select option[value=' + disabilityToHide + ']').prop('disabled', true);
        modal.find('select').select2('destroy').select2().select2('val', modal.find('select option:eq(2)').val());
        modal.find('.tutor_group_id').val(disabilityToHide);
        modal.find('.groupName').prepend('<span class="tutorText">' + tutor + '</span>');
    });

    //Year Groups
    $('#yearModal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget);
        var disabilityToHide = button.data('hideid');
        var tutor = button.data('tutorname');
        $(".tutorText").remove();

        var modal = $(this);
        modal.find('select option').prop('disabled', false);
        modal.find('select option[value=' + disabilityToHide + ']').prop('disabled', true);
        modal.find('select').select2('destroy').select2().select2('val', modal.find('select option:eq(2)').val());
        modal.find('.year_group_id').val(disabilityToHide);
        modal.find('.groupName').prepend('<span class="tutorText">' + tutor + '</span>');
    });

    //User Groups
    $('#userGroupModal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget);
        var groupToHide = button.data('hideid');
        var tutor = button.data('groupname');
        $(".userGroupText").remove();

        var modal = $(this);
        modal.find('select option').prop('disabled', false);
        modal.find('select option[value=' + groupToHide + ']').prop('disabled', true);
        modal.find('select').select2('destroy').select2().select2('val', modal.find('select option:eq(2)').val());
        modal.find('.user_group_id').val(groupToHide);
        modal.find('.groupName').prepend('<span class="userGroupText">' + tutor + '</span>');
    });

    //Ethnicities
    $('#ethnicityModal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget);
        var disabilityToHide = button.data('hideid');
        var tutor = button.data('tutorname');
        $(".tutorText").remove();

        var modal = $(this);
        modal.find('select option').prop('disabled', false);
        modal.find('select option[value=' + disabilityToHide + ']').prop('disabled', true);
        modal.find('select').select2('destroy').select2().select2('val', modal.find('select option:eq(2)').val());
        modal.find('.ethnicity_id').val(disabilityToHide);
        modal.find('.groupName').prepend('<span class="tutorText">' + tutor + '</span>');
    });

    //Key Stages
    $('#keyStageModal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget);
        var disabilityToHide = button.data('hideid');
        var tutor = button.data('tutorname');
        $(".tutorText").remove();

        var modal = $(this);
        modal.find('select option').prop('disabled', false);
        modal.find('select option[value=' + disabilityToHide + ']').prop('disabled', true);
        modal.find('select').select2('destroy').select2().select2('val', modal.find('select option:eq(2)').val());
        modal.find('.key_stage_id').val(disabilityToHide);
        modal.find('.groupName').prepend('<span class="tutorText">' + tutor + '</span>');
    });

    //Zones
    $('#zoneModal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget);
        var zoneToHide = button.data('hideid');
        var zone = button.data('zonename');
        $(".zoneText").remove();

        var modal = $(this);
        modal.find('select option').prop('disabled', false);
        modal.find('select option[value=' + zoneToHide + ']').prop('disabled', true);
        modal.find('select').select2('destroy').select2().select2('val', modal.find('select option:eq(2)').val());
        modal.find('.zone_id').val(zoneToHide);
        modal.find('.groupName').prepend('<span class="zoneText">' + zone + '</span>');
    });

    // fileType select-multiple was not recognised
    if (typeof fieldType !== 'undefined' && fieldType && (fieldType.substring(0, 6) == 'select' || fieldType == 'checkboxes')) {
        $('#inputOptions').show();
        $('#source-container').show();
        $('#inputSource').show();
    } else {
        $('#inputOptions').hide();
        $('#source-container').hide();
        $('#inputSource').hide();
    }

    $('#input_type').on('change', function() {
        var value = this.value;
        if (value == 'select' || value == 'checkboxes' || value == 'select-multiple') {
            $('#inputSource').show();
            $('#source-container').show();
            if (value == 'checkboxes') {
                $('#source option[value!="user"]').attr('disabled', true);
                $('#source').select2();
            } else {
                $('#source option[value!="user"]').attr('disabled', false);
                $('#source').select2();
            }
            if ($('#source').val() == 'user') {
                $('#inputOptions').show();
            }
        } else {
            $('#inputOptions').hide();
            $('#inputSource').hide();
            $('#source-container').hide();
        }
    });

    $('#source').on('change', function() {
        var value = this.value;
        if (value != 'user') {
            $('#inputOptions').hide();
            return false;
        }
        $('#inputOptions').show();
    });
});